import './shared/tokens/fonts.ts';
import './shared/tokens/tokens.css';
import './shared/tokens/colors.css';
import './shared/tokens/base.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.tsx';
import { createAppServices } from './app/composition.ts';

const container = document.getElementById('root');
if (!container) throw new Error('The page has no #root element');

createRoot(container).render(
  <StrictMode>
    <App services={createAppServices()} />
  </StrictMode>,
);
